import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "../components/flexproducts";
import Header from "../headers_footer/header";

const Hairserum = () => {

return (

<div>

<Navbar />
<Flexproducts type="hairserum" />
<Header></Header>

</div>

);
};

export default Hairserum;